import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isiOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    if (localStorage.getItem("lci-install-dismissed") === "1") return;

    const onBip = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBip);

    // iOS Safari no dispara beforeinstallprompt → mostrar ayuda manual
    if (isiOS()) {
      const t = setTimeout(() => { setIosHelp(true); setVisible(true); }, 2500);
      return () => { window.removeEventListener("beforeinstallprompt", onBip); clearTimeout(t); };
    }
    return () => window.removeEventListener("beforeinstallprompt", onBip);
  }, []);

  const dismiss = () => { localStorage.setItem("lci-install-dismissed", "1"); setVisible(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    dismiss();
  };

  if (!visible) return null;

  return (
    <div className="install-prompt" data-testid="install-prompt">
      <div className="install-icon"><Download size={20} /></div>
      <div className="install-txt">
        <b>Descarga la app de Liberti Club IA</b>
        {iosHelp ? (
          <span>Pulsa <Share size={13} style={{ verticalAlign: "-2px" }} /> <b>Compartir</b> y luego <b>“Añadir a pantalla de inicio”</b>.</span>
        ) : (
          <span>Instálala en tu móvil para entrar más rápido y recibir avisos.</span>
        )}
      </div>
      <div className="install-actions">
        {!iosHelp && <button className="btn btn-gold btn-sm" data-testid="install-btn" onClick={install}>Instalar</button>}
        <button className="install-close" data-testid="install-dismiss" onClick={dismiss} aria-label="Cerrar"><X size={16} /></button>
      </div>
    </div>
  );
}
